app = angular.module("seismology")

app.controller "BookDialogCtrl", ($scope, Books, book) ->
  console.log book
  $scope.book = book
  



// WEBPACK FOOTER //
// ./app/controllers/book_controllers.coffee